import React from 'react'
import { useSelector } from 'react-redux'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { Rdrct } from 'src/navigation/Lnk'
import { expenseRequirementsAdditionalFieldsRouteProps } from 'src/navigation/routeProps'
import { expenseCategoriesAdditionalFieldsUrl } from 'src/navigation/urls'
import { selectOrganizationIdFromRoute } from 'src/redux/selectors/data/organizations.selectors'

const ExpenseRequirementsAdditionalFieldsRedirect: React.FC = () => {
  const organizationId = useSelector(selectOrganizationIdFromRoute)
  // Wait for the org id to resolve from the route before redirecting; an empty
  // id would build /organizationSettings//... and strand the user on a 404.
  if (organizationId === undefined) {
    return null
  }
  return (
    <Rdrct to={expenseCategoriesAdditionalFieldsUrl(organizationId)} />
  )
}

const ExpenseRequirementsAdditionalFieldsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseRequirementsAdditionalFields,
  routeProps: expenseRequirementsAdditionalFieldsRouteProps,
  component: <ExpenseRequirementsAdditionalFieldsRedirect />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseRequirementsAdditionalFieldsAppRoute
